//! DO NOT IMPORT FROM THIS FILE - USE './theme-selectors.ts' INSTEAD
export var getShadowOne = function (theme) {
    return theme.v1.shadows.one;
};
export var getShadowTwo = function (theme) {
    return theme.v1.shadows.two;
};
export var getShadowThree = function (theme) {
    return theme.v1.shadows.three;
};
export var getShadowFour = function (theme) {
    return theme.v1.shadows.four;
};
export var getShadowFive = function (theme) {
    return theme.v1.shadows.five;
};
export var getShadowSix = function (theme) {
    return theme.v1.shadows.six;
};
